export default "__VITE_ASSET__CKgOc15i__"